export default "__VITE_ASSET__HgzSjcEd__"